module.exports = __webpack_public_path__ + "static/media/deliverAgentIco2.04ce0a44.svg";